import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import { formValidator } from '../middlewares/formValidator';
import { performanceChecker } from '../middlewares/performanceChecker';
import { reportValidator } from '../middlewares/reportValidator';
import { waitForLogin } from '../middlewares/waitForLogin';
import rootReducer from '../reducers/RootReducer';
import { getEnvVar } from '../utils/env';
import { getPrefixedKey } from '../utils/envLocalStorage';

const actorCode = localStorage.getItem('actorCode') ?? localStorage.getItem('prevActorCode');

const persistConfig = {
  key: getPrefixedKey(actorCode),
  storage,
  whitelist: ['savedSearchFilters', 'savedSearchResults'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line

const middlewares = [thunk, waitForLogin, formValidator, reportValidator, performanceChecker];

if (getEnvVar('REACT_APP_ENABLE_REDUX_LOGGER') === true) {
  const { createLogger } = require('redux-logger');
  const logger = createLogger({
    collapsed: () => true,
    duration: true,
  });
  middlewares.push(logger);
}

export default function configureStore(initialState = {}) {
  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  const persistor = persistStore(store);

  return { store, persistor };
}
